<template>
  <div class="dish-showcase">
    <!-- 侧边分类菜单 -->
    <div class="sidebar">
      <div class="sidebar-title">菜品分类</div>
      <ul class="category-list">
        <li><router-link to="/cp/mycp1" exact-active-class="active">荤菜</router-link></li>
        <li><router-link to="/cp/mycp5" exact-active-class="active">半荤菜</router-link></li>
        <li><router-link to="/cp/mycp2" exact-active-class="active">素菜</router-link></li>
        <li><router-link to="/cp/mycp3" exact-active-class="active">主食甜点</router-link></li>
        <li><router-link to="/cp/mycp4" exact-active-class="active">精品小吃</router-link></li>
      </ul>
    </div>

    <!-- 菜品网格区域 -->
    <div class="dish-grid">
      <!-- 主食板块 -->
      <div class="section-title">🍚 主食</div>
      <div class="grid-container">
        <div class="dish-card" v-for="(dish, idx) in stapleList" :key="'staple' + idx">
          <el-image
            class="dish-img"
            :src="dish.thumb"
            :preview-src-list="[dish.preview]"
            fit="cover"
          >
            <div slot="error" class="error-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="dish-info">
            <span class="dish-name">{{ dish.name }}</span>
          </div>
        </div>
      </div>

      <!-- 甜品板块 -->
      <div class="section-title">🍰 甜品</div>
      <div class="grid-container">
        <div class="dish-card" v-for="(dish, idx) in dessertList" :key="'dessert' + idx">
          <el-image
            class="dish-img"
            :src="dish.thumb"
            :preview-src-list="[dish.preview]"
            fit="cover"
          >
            <div slot="error" class="error-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <div class="dish-info">
            <span class="dish-name">{{ dish.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 主食数据（图片名称根据实际文件命名）
      stapleList: [
        { name: '白米饭', thumb: require('../../assets/cp/jbc/zstp/01.jpg'), preview: require('../../assets/cp/jbc/zstp/01-b.jpg') },
        { name: '花卷', thumb: require('../../assets/cp/jbc/zstp/02.jpg'), preview: require('../../assets/cp/jbc/zstp/02-b.jpg') },
        { name: '馒头', thumb: require('../../assets/cp/jbc/zstp/03.jpg'), preview: require('../../assets/cp/jbc/zstp/03-b.jpg') },
        { name: '发糕', thumb: require('../../assets/cp/jbc/zstp/04.jpg'), preview: require('../../assets/cp/jbc/zstp/04-b.jpg') },
        { name: '豆沙包', thumb: require('../../assets/cp/jbc/zstp/05.jpg'), preview: require('../../assets/cp/jbc/zstp/05-b.jpg') },
        { name: '玉米段', thumb: require('../../assets/cp/jbc/zstp/06.jpg'), preview: require('../../assets/cp/jbc/zstp/06-b.jpg') },
        { name: '紫薯包', thumb: require('../../assets/cp/jbc/zstp/07.jpg'), preview: require('../../assets/cp/jbc/zstp/07-b.jpg') },
        { name: '窝窝头', thumb: require('../../assets/cp/jbc/zstp/08.jpg'), preview: require('../../assets/cp/jbc/zstp/08-b.jpg') },
        { name: '南瓜饼', thumb: require('../../assets/cp/jbc/zstp/09.jpg'), preview: require('../../assets/cp/jbc/zstp/09-b.jpg') },
        { name: '杂粮饭', thumb: require('../../assets/cp/jbc/zstp/10.jpg'), preview: require('../../assets/cp/jbc/zstp/10-b.jpg') },
        { name: '小米粥', thumb: require('../../assets/cp/jbc/zstp/11.jpg'), preview: require('../../assets/cp/jbc/zstp/11-b.jpg') },
        { name: '八宝饭', thumb: require('../../assets/cp/jbc/zstp/12.jpg'), preview: require('../../assets/cp/jbc/zstp/12-b.jpg') },
        { name: '烧麦', thumb: require('../../assets/cp/jbc/zstp/13.jpg'), preview: require('../../assets/cp/jbc/zstp/13-b.jpg') },
        { name: '蛋炒饭', thumb: require('../../assets/cp/jbc/zstp/14.jpg'), preview: require('../../assets/cp/jbc/zstp/14-b.jpg') },
        { name: '葱油饼', thumb: require('../../assets/cp/jbc/zstp/15.jpg'), preview: require('../../assets/cp/jbc/zstp/15-b.jpg') },
        { name: '煎饺', thumb: require('../../assets/cp/jbc/zstp/16.jpg'), preview: require('../../assets/cp/jbc/zstp/16-b.jpg') },
      ],
      // 甜品数据
      dessertList: [
        { name: '蛋挞', thumb: require('../../assets/cp/jbc/zstp/22.jpg'), preview: require('../../assets/cp/jbc/zstp/22-b.jpg') },
        { name: '芝士蛋糕', thumb: require('../../assets/cp/jbc/zstp/23.jpg'), preview: require('../../assets/cp/jbc/zstp/23-b.jpg') },
        { name: '慕斯杯', thumb: require('../../assets/cp/jbc/zstp/24.jpg'), preview: require('../../assets/cp/jbc/zstp/24-b.jpg') },
        { name: '水果布丁', thumb: require('../../assets/cp/jbc/zstp/25.jpg'), preview: require('../../assets/cp/jbc/zstp/25-b.jpg') },
        { name: '双皮奶', thumb: require('../../assets/cp/jbc/zstp/26.jpg'), preview: require('../../assets/cp/jbc/zstp/26-b.jpg') },
        { name: '酸奶杯', thumb: require('../../assets/cp/jbc/zstp/27.jpg'), preview: require('../../assets/cp/jbc/zstp/27-b.jpg') },
        { name: '绿豆糕', thumb: require('../../assets/cp/jbc/zstp/28.jpg'), preview: require('../../assets/cp/jbc/zstp/28-b.jpg') },
        { name: '草莓慕斯', thumb: require('../../assets/cp/jbc/zstp/29.jpg'), preview: require('../../assets/cp/jbc/zstp/29-b.jpg') },
        { name: '巧克力卷', thumb: require('../../assets/cp/jbc/zstp/30.jpg'), preview: require('../../assets/cp/jbc/zstp/30-b.jpg') },
        { name: '红豆汤圆', thumb: require('../../assets/cp/jbc/zstp/31.jpg'), preview: require('../../assets/cp/jbc/zstp/31-b.jpg') },
        { name: '驴打滚', thumb: require('../../assets/cp/jbc/zstp/32.jpg'), preview: require('../../assets/cp/jbc/zstp/32-b.jpg') },
        { name: '桂花糕', thumb: require('../../assets/cp/jbc/zstp/33.jpg'), preview: require('../../assets/cp/jbc/zstp/33-b.jpg') },
        { name: '芝麻球', thumb: require('../../assets/cp/jbc/zstp/34.jpg'), preview: require('../../assets/cp/jbc/zstp/34-b.jpg') },
        { name: '椰奶冻', thumb: require('../../assets/cp/jbc/zstp/35.jpg'), preview: require('../../assets/cp/jbc/zstp/35-b.jpg') },
        { name: '芒果班戟', thumb: require('../../assets/cp/jbc/zstp/36.jpg'), preview: require('../../assets/cp/jbc/zstp/36-b.jpg') },
        { name: '提拉米苏', thumb: require('../../assets/cp/jbc/zstp/37.jpg'), preview: require('../../assets/cp/jbc/zstp/37-b.jpg') },
      ]
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dish-showcase {
  max-width: 80%;
  margin: 30px auto;
  padding: 0 20px;
  display: flex;
  gap: 30px;
}

/* 侧边菜单 */
.sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  height: fit-content;
  transition: box-shadow 0.2s;
}
.sidebar:hover {
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.1);
}
.sidebar-title {
  background: linear-gradient(135deg, #f97316, #facc15);
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 16px 0;
  letter-spacing: 2px;
}
.category-list {
  list-style: none;
  padding: 12px 0;
}
.category-list li {
  margin: 0;
}
.category-list a {
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.25s;
  border-left: 3px solid transparent;
}
.category-list a:hover {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  padding-left: 28px;
}
.category-list a.active {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  font-weight: 600;
}

/* 右侧菜品区域 */
.dish-grid {
  flex: 1;
}

.section-title {
  font-size: 24px;
  font-weight: 600;
  color: #f97316;
  margin: 20px 0 16px;
  padding-left: 12px;
  border-left: 5px solid #f97316;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 28px;
  margin-bottom: 40px;
}

/* 卡片样式 */
.dish-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s, box-shadow 0.3s;
}
.dish-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 24px 36px -12px rgba(0, 0, 0, 0.15);
}
.dish-card:hover .dish-info {
  background: #b03e45;
}
.dish-card:hover .dish-info .dish-name {
  color: #fff;
}
.dish-img {
  width: 100%;
  height: 200px;
  display: block;
  background: #f5f5f5;
}
.dish-img /deep/ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}
.dish-card:hover .dish-img /deep/ img {
  transform: scale(1.04);
}
.dish-info {
  padding: 16px 16px 20px;
  text-align: center;
  background: #fff;
  transition: background 0.2s;
}
.dish-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  letter-spacing: 1px;
  transition: color 0.2s;
}
.error-slot {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #cbd5e0;
  background: #f8fafc;
}

/* 响应式布局 */
@media (max-width: 1024px) {
  .dish-showcase {
    padding: 0 20px;
  }
  .grid-container {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 24px;
  }
}


</style>